import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/tmp/vultr-2-runner/work/kastle/kastle/packages/mdx/src/components/Layout/Default.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Form = makeShortcode("Form");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "location-de-salles-entre-nancy-et-metz"
    }}><strong parentName="h1">{`Location de salles`}</strong>{` entre `}<strong parentName="h1">{`Nancy`}</strong>{` et `}<strong parentName="h1">{`Metz`}</strong></h1>
    <h2 {...{
      "id": "demande-dinformation-pour-location-de-salles"
    }}>{`Demande d’information pour location de salles`}</h2>
    <Form url="https://form.typeform.com/to/LQT69N" mdxType="Form" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      